import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SWAP_TO_YEAR_ADVERT_BUTTON: `${cleanedFilename(
    __filename,
  )}-swap-to-year-advert-button`,
  GO_TO_CANCEL_STEP: `${cleanedFilename(__filename)}-go-to-cancel-step`,
};
